import { EExchangeType } from "@domains/features/Markets/Equity/entities/iTopGainersLosers";
export var SearchAssetTypeEnum;
(function (SearchAssetTypeEnum) {
    SearchAssetTypeEnum["Equity"] = "Equity";
    SearchAssetTypeEnum["Future"] = "Future";
    SearchAssetTypeEnum["Option"] = "Option";
    SearchAssetTypeEnum["OptionChain"] = "OptionChain";
    SearchAssetTypeEnum["MF"] = "MF";
    SearchAssetTypeEnum["PrimaryMarket"] = "PrimaryMarket";
    SearchAssetTypeEnum["Commodity"] = "Commodity";
    SearchAssetTypeEnum["ComFut"] = "COMFUT";
    SearchAssetTypeEnum["ComOpt"] = "COMOPT";
    SearchAssetTypeEnum["Currency"] = "Currency";
    SearchAssetTypeEnum["ETFs"] = "ETFs";
    SearchAssetTypeEnum["Indices"] = "Indices";
    SearchAssetTypeEnum["NcdSecondary"] = "NcdSecondary";
    // SGB = "SGB",
    // CORPFD = "CORPFD",
})(SearchAssetTypeEnum || (SearchAssetTypeEnum = {}));
export var SearchPrimaryMarketType;
(function (SearchPrimaryMarketType) {
    SearchPrimaryMarketType["IPO"] = "IPO";
    SearchPrimaryMarketType["NCD"] = "NCD";
    SearchPrimaryMarketType["NFO"] = "NFO";
    SearchPrimaryMarketType["OFS"] = "OFS";
})(SearchPrimaryMarketType || (SearchPrimaryMarketType = {}));
export var CallPut;
(function (CallPut) {
    CallPut["CALL"] = "CE";
    CallPut["PUT"] = "PE";
})(CallPut || (CallPut = {}));
export const dropDownCallPut = [
    {
        display: "Calls",
        value: CallPut.CALL,
    },
    {
        display: "Puts",
        value: CallPut.PUT,
    },
];
export const searchFilters = [
    {
        filterName: SearchAssetTypeEnum.Equity,
        eventKey: SearchAssetTypeEnum.Equity,
        list: [
            { title: "NSE ", key: EExchangeType.NSE, selected: false },
            { title: " BSE", key: EExchangeType.BSE, selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: SearchAssetTypeEnum.Currency,
        eventKey: SearchAssetTypeEnum.Currency,
        list: [
            { title: "FUT", key: "FUT", selected: false },
            { title: "OPT", key: "OPT", selected: false },
        ],
        selectType: "select",
    },
    {
        filterName: SearchAssetTypeEnum.ComOpt,
        eventKey: SearchAssetTypeEnum.ComOpt,
        list: [
            { title: "MCX", key: "MCX", selected: false },
            { title: "NCDEX", key: "NCDEX", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: SearchAssetTypeEnum.ComFut,
        eventKey: SearchAssetTypeEnum.ComFut,
        list: [
            { title: "MCX", key: "MCX", selected: false },
            { title: "NCDEX", key: "NCDEX", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: SearchAssetTypeEnum.PrimaryMarket,
        eventKey: SearchAssetTypeEnum.PrimaryMarket,
        list: [
            { title: "IPO", key: "IPO", selected: false },
            { title: "NFO", key: "NFO", selected: false },
            { title: "NCD IPO", key: "NCD IPO", selected: false },
            { title: "OFS", key: "OFS", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: SearchAssetTypeEnum.MF,
        eventKey: SearchAssetTypeEnum.MF,
        list: [
            { title: "Equity", key: "Equity", selected: false },
            { title: "Debt", key: "Debt", selected: false },
            { title: "Hybrid", key: "Hybrid", selected: false },
            { title: "ELSS", key: "ELSS", selected: false },
            { title: "Other", key: "Other", selected: false },
        ],
        selectType: "checkbox",
    },
];
